// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { lightlinkPhoenix as _lightlinkPhoenix } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the lightlinkPhoenix chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1890
 * Chain Name: LightLink Phoenix Mainnet
 * Default Block Explorer: https://phoenix.lightlink.io
 * Default RPC URL: https://replicator.phoenix.lightlink.io/rpc/v1
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { lightlinkPhoenix } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: lightlinkPhoenix,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const lightlinkPhoenix = createCommon({
	..._lightlinkPhoenix,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
